import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from "./modal";
import ReactDom from "react-dom";
var CosmostationWCModal = /** @class */ (function () {
    function CosmostationWCModal() {
    }
    CosmostationWCModal.prototype.open = function (uri, cb) {
        var _this = this;
        var wrapper = document.createElement("div");
        wrapper.setAttribute("id", "cosmostation-wc-modal");
        document.body.appendChild(wrapper);
        ReactDom.render(_jsx(Modal, { uri: uri, close: function () {
                _this.close();
                cb();
            } }), wrapper);
    };
    CosmostationWCModal.prototype.close = function () {
        var wrapper = document.getElementById("cosmostation-wc-modal");
        if (wrapper) {
            document.body.removeChild(wrapper);
        }
    };
    return CosmostationWCModal;
}());
export { CosmostationWCModal };
